<div class="header-navigation-back">
  <mat-icon (click)="onNavigateToProfile()">arrow_back</mat-icon>
  <span class="title">Abstract</span>
</div>
@if (loading) {
  <app-loading-gif></app-loading-gif>
}
<div  class="content full-height">
  @if (uploaded && !loading) {
    <div class="padding-left-md padding-right-md">
      <p>Your Driver Abstract document was uploaded to our system on {{ createdDate }}.</p>
      <p>
        If you need further assistance, please get in touch with one of our support group at
        <a href="mailto:{{ this.supportEmail }}">{{ this.supportEmail }}.</a>
      </p>
    </div>
  }
  @if (!uploaded && !loading) {
    <div class="help-text padding-left-md padding-right-md">
      <p>
        email us at <a href="mailto:{{ this.supportEmail }}" class="help-text">{{ this.supportEmail }}.</a> if you have
        questions
      </p>
    </div>
  }
  @if (!uploaded && !loading && !attempted) {
    <div class="content padding-left-sm padding-right-sm">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="abstractForm">
        <mat-form-field>
          <input matInput placeholder="Report Source" formControlName="reportSource" required />
          @if (reportSource.touched && reportSource.invalid) {
            <mat-error>
              {{ getReportSourceErrorMessage() }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <input matInput readonly placeholder="Report Generation Date" [matDatepicker]="generationDate"
            formControlName="generationDate" [max]="presentDate" (focus)="generationDate.open()"
            (click)="generationDate.open()" required />
          <mat-datepicker-toggle matSuffix [for]="generationDate"></mat-datepicker-toggle>
          <mat-datepicker touchUi="true" #generationDate></mat-datepicker>
          @if (generationDate.touched && generationDate.invalid) {
            <mat-error>
              {{ getGenerationDateErrorMessage() }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <input matInput readonly placeholder="Valid till" [matDatepicker]="validToDate" formControlName="validToDate"
            [min]="presentDate" required />
          <mat-datepicker-toggle matSuffix [for]="validToDate"></mat-datepicker-toggle>
          <mat-datepicker touchUi="true" #validToDate></mat-datepicker>
          @if (validToDate.touched && validToDate.invalid) {
            <mat-error>
              {{ getValidToDateErrorMessage() }}
            </mat-error>
          }
        </mat-form-field>
      </form>
    </div>
  }
</div>
@if (!uploaded && !loading) {
  <div  class="botttom-position">
    <div >
      @if (errorMessage) {
        <mat-error class="error padding-bottom-sm">
          {{ errorMessage }}
        </mat-error>
      }
      @if (successMessage) {
        <p>
          {{ successMessage }}
        </p>
      }
    </div>
    @if (attempted) {
      <button mat-raised-button class="select-file-button" type="button" [disabled]="!attempted"
        (click)="onNavigateToProfile()">
        Back
      </button>
    }
    @if (!attempted) {
      <button mat-raised-button class="select-file-button" type="button"
        [disabled]="loading || !form.dirty || !form.valid || successMessage" (click)="fileToUpload.click()">
        Upload
      </button>
    }
    <input mat-input #fileToUpload type="file" accept="application/pdf, .jpeg, .jpg"
      [disabled]="loading || !form.dirty || !form.valid || successMessage" (change)="onFileChange(fileToUpload)"
      class="hidden-input-field" />
  </div>
}